export enum IdentityProvider {
  ID = 'id',
  PASSPORT = 'passport',
}
